import React, { useEffect } from "react";
import {
  Authenticator,
  Greetings,
  SignIn,
  ForgotPassword,
  RequireNewPassword,
  Loading,
  VerifyContact,
  ConfirmSignIn,
} from "aws-amplify-react";
import LighthouseAmplifyTheme from "components/common/auth/config/amplify-theme";
import { CustomSignIn } from "./SignIn";
import { CustomForgotPassword } from "components/common/auth/ForgotPassword";
import { CustomRequireNewPassword } from "components/common/auth/RequireNewPassword";
import AuthUserWrapper from "components/common/auth/AuthUserWrapper";
import { CustomLoadingState } from "components/common/auth/Loading";
import { CustomVerifyContact } from "components/common/auth/VerifyContact";
import { CustomConfirmSignIn } from "components/common/auth/ConfirmSignIn";
import { useHistory } from "react-router";
import { CustomResetPassword } from "components/common/auth/ResetPasswordFromEmail";

const RESET_PASSWORD_HASHBANG = "reset-password";

interface RootProps {
  children: React.ReactNode;
  authState?: string;
}
const SignedInRoutes = ({ authState, children }: RootProps) => {
  return authState === "signedIn" ? <>{children}</> : null;
};

interface Props {
  children: React.ReactNode;
}

const AuthWrapper = (props: Props) => {
  const history = useHistory();

  const authProps =
    history.location.hash === `#${RESET_PASSWORD_HASHBANG}`
      ? { authState: "resetPassword" }
      : {};

  useEffect(() => {
    //Strip hashbang from URL after loaded
    if (history.location.hash === `#${RESET_PASSWORD_HASHBANG}`) {
      history.replace({
        pathname: history.location.pathname,
        search: history.location.search,
      });
    }
  }, [history]);
  return (
    <Authenticator
      hide={[
        SignIn,
        ForgotPassword,
        RequireNewPassword,
        Greetings,
        Loading,
        VerifyContact,
        ConfirmSignIn,
      ]}
      theme={LighthouseAmplifyTheme}
      {...authProps}
    >
      <CustomSignIn />
      <CustomForgotPassword />
      <CustomRequireNewPassword />
      <CustomResetPassword />
      <CustomVerifyContact />
      <CustomLoadingState />
      <CustomConfirmSignIn />
      <SignedInRoutes>
        <AuthUserWrapper>{props.children}</AuthUserWrapper>
      </SignedInRoutes>
    </Authenticator>
  );
};

export default AuthWrapper;
